import { render, staticRenderFns } from "./CreateSegmentForm.vue?vue&type=template&id=5c2cceac"
import script from "./CreateSegmentForm.vue?vue&type=script&lang=js"
export * from "./CreateSegmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports